import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxFileUploaderComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';
import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './distributors.page.html',
})

// tslint:disable-next-line:component-class-suffix
export class DistributorsPage extends BasePage {
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent;
    @ViewChild('grid') grid: DxDataGridComponent;
    @ViewChild("fileUploader") fileUploader: DxFileUploaderComponent;

    files: any[] = [];
    editRow: any = {};
    popupEditVisible = false;
    couponList: any[] = [];
    loadingVisible = false;
    loadID: object;
    saveID: object;

    get uploadUrl(): string {
        return environment.api_url + "/Distributor/Upload";
    }
    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
    }

    onMenuItemClick(e) {
        switch (e.name) {
            case "DXInsert":
                {
                    e.handled = true;
                    this.popupEditVisible = true;
                    this.editRow = { Title: null };
                    this.files = [];
                    break;
                }
            case "DXEdit":
                {
                    e.handled = true;
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        this.files = [];
                        Object.assign(this.editRow, this.grid.instance.getSelectedRowsData()[0]); 
                        let bstr =  window.atob(this.editRow.LogoBase64), n = bstr.length, u8arr = new Uint8Array(n);
                        while(n--){
                            u8arr[n] = bstr.charCodeAt(n);
                        } 
                        this.files.push(new File([u8arr], "test.png")); 
                        this.popupEditVisible = true;
                    }
                    break;
                }
        }
    }

    getID() {
        const list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            this.loadID = { id: list[0] };
            this.saveID = { MarketerID: list[0] };
        }
    }

    save() {
        if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/Distributor/Save", this.editRow).then(() => {
                this.grid.instance.refresh();
                this.files = [];
                this.popupEditVisible = false;
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    onRemoveClick() {
       this.popupEditVisible = false;
    }

    onUploaded(e) {
        try {
            this.editRow.LogoBase64 = JSON.parse(e.request.response);
        } catch (error) {
            this.fileUploader.instance.reset();
            this.uiService.error(error.message);
        }
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Marketer/distributors.page.ts